import React, {Component} from "react"
import get from "lodash/get"
import {FormattedMessage} from "@irati/utils/lang"
import {H1} from "@irati/ui/src/Typography"
import {SSO_TYPE_NONE} from "@irati/sso/constants/signUpOptions"

import withAuth, {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import SignUpOptions from "./SignUpOptions"

interface Props extends WithAuth {
  handleSave: () => void
}
interface State {
  activeOption: string
  savedOption: string
  ssoButtonText: string
}
class SignUpSettings extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const currentOption = get(props.auth.userTenant, "settings.signUpOption", "none")
    this.state = {
      activeOption: currentOption,
      savedOption: currentOption,
      ssoButtonText: get(props.auth.userTenant, "settings.ssoButtonText", "")
    }
  }

  updateOption = (option: string) => {
    if (this.state.activeOption === option) {
      return false
    }
    this.setState({
      activeOption: option
    })
  }

  handleSave = () => {
    if (this.state.activeOption === SSO_TYPE_NONE) {
      this.setState({savedOption: SSO_TYPE_NONE})
    }
    this.props.handleSave()
  }

  render() {
    const {
      auth: {userTenant}
    } = this.props
    const {activeOption, savedOption, ssoButtonText} = this.state

    return (
      <>
        <H1>
          <FormattedMessage id="admin.containers.companySignUpSettings.heading" />
        </H1>
        <SignUpOptions
          onClick={this.updateOption}
          activeOption={activeOption}
          savedOption={savedOption}
          ssoButtonText={ssoButtonText}
          saveChanges={this.changeSignUpOption}
          userTenant={userTenant}
          handleSave={this.handleSave}
        />
      </>
    )
  }
}

export default withAuth(SignUpSettings)
